import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthStateService } from '../auth/auth-state.service'

export function adminAuthGuard(options: {
    redirectTo: string[]
}): CanActivateFn {
    return () => {
        const authStateService = inject(AuthStateService)
        const router = inject(Router)

        // if (authStateService.isAuthenticated()) {
        //     return true
        // }

        return router.createUrlTree(options.redirectTo)
    }
}
